import { ProductSearchSharedState } from "./product-search-shared-state.interface";

export function createProductSearchSharedState(): ProductSearchSharedState {
  return {
    categories: null,
    subcategories: null,
    loading: false,
    error: null,
  };
}
